var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUiEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.475 4.99-8.546 8.546-.707 4.242 4.242-.707 8.546-8.546zM14.303 2.161l-2.121 2.121 3.535 3.536 2.122-2.121a1 1 0 0 0 0-1.414L15.717 2.16a1 1 0 0 0-1.414 0"
})));
export default SvgUiEdit;